/* eslint-disable arrow-body-style */
// @ts-nocheck
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Actions from '../../actions'
import Operations from '../../operations'
import { showToast } from '../../common/utils'

const Modal = (Modal, modalId) => {
  class WrappedModal extends Component {
    render() {
      return <Modal showToast={showToast} {...this.props} />
    }
  }

  WrappedModal.propTypes = {
    clear: PropTypes.func.isRequired,
    close: PropTypes.func.isRequired,
    createItem: PropTypes.func.isRequired,
    errors: PropTypes.array,
    features: PropTypes.object,
    fetchList: PropTypes.func.isRequired,
    setLoadedListItem: PropTypes.func.isRequired,
    isOpen: PropTypes.bool,
    isSubmitting: PropTypes.bool,
    setFormField: PropTypes.func.isRequired,
    setFormState: PropTypes.func.isRequired,
    updateItem: PropTypes.func.isRequired,
    user: PropTypes.object,
    validationErrors: PropTypes.object,
  }

  const mapStateToProps = (state) => {
    return {
      ...state.modals[modalId],
      ...state.forms[modalId],
      features: state.global.home,
      user: state.global.user,
    }
  }

  const mapDispatchToProps = (dispatch) => {
    return {
      clear: () => dispatch(Actions.clearForm(modalId)),
      close: () => {
        dispatch(Actions.closeModal(modalId))
        dispatch(Actions.removeForm(modalId))
      },
      updateItem: (data) =>
        dispatch(
          Operations.postItem({ ...data, formId: modalId, method: 'PUT' })
        ),
      createItem: (data) =>
        dispatch(
          Operations.postItem({ ...data, formId: modalId, method: 'POST' })
        ),
      fetchList: (list, query, url) =>
        dispatch(Operations.loadList(list, query, undefined, url)),
      setLoadedListItem: (list, data) =>
        dispatch(Actions.setLoadedListItem(list, data)),
      setFormField: ({ key, value }) =>
        dispatch(Actions.setFormField({ key, value, formId: modalId })),
      setFormState: ({ key, value }) =>
        dispatch(Actions.setFormState({ key, value, formId: modalId })),
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)(WrappedModal)
}

export default Modal
